import { render } from "./CompleteStatus.vue?vue&type=template&id=ec7bd256&scoped=true&ts=true"
import script from "./CompleteStatus.vue?vue&type=script&lang=ts"
export * from "./CompleteStatus.vue?vue&type=script&lang=ts"

import "./CompleteStatus.vue?vue&type=style&index=0&id=ec7bd256&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7bd256"],['__file',"src/components/kyc/CompleteStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec7bd256"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec7bd256', __exports__)) {
    api.reload('ec7bd256', __exports__)
  }
  
  module.hot.accept("./CompleteStatus.vue?vue&type=template&id=ec7bd256&scoped=true&ts=true", () => {
    api.rerender('ec7bd256', render)
  })

}


export default __exports__